import {
  logoFooter,
  logoFooterDialog,
  logoFooterText,
} from '@mage-ui/styled-system/recipes';
import { LogoSymbol } from './LogoSymbol';
import { LogoWrapper } from './LogoWrapper';

export const LogoEoiFooter = (props) => {
  return (
    <LogoWrapper className={logoFooter()} {...props}>
      <LogoSymbol
        className={logoFooterDialog()}
        title='Logo Footer Dialog EOI'
        symbol='logo-footer-dialog-eoi'
        viewBox='0 0 85 52'
      />
      <LogoSymbol
        className={logoFooterText()}
        title='Logo Footer Text EOI'
        symbol='logo-txt-eoi'
        viewBox='0 0 80 23'
      />
    </LogoWrapper>
  );
};
